import { render, staticRenderFns } from "./DepositCollectedCard.vue?vue&type=template&id=72802641&"
import script from "./DepositCollectedCard.vue?vue&type=script&lang=js&"
export * from "./DepositCollectedCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports